import React from 'react';

import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import { openDialog } from 'actions/payment';
import { openPurchaseDialog } from 'actions/fate';

import getVisibleFateCards from 'selectors/fate/getVisibleFateCards';
import { IAppState } from 'types/app';

import FateComponent from './FateComponent';

type Props = RouteComponentProps & ReturnType<typeof mapStateToProps> & {
  dispatch: Function,
};

class Fate extends React.Component<Props> {
  static displayName = 'FateContainer';

  handleClickBuyFateButton = () => {
    this.openPurchaseDialog('buy');
  };

  /**
   * Open Purchase dialog
   * @param  {Object} item
   * @return {undefined}
   */
  openPurchaseDialog = (item: any) => {
    const { dispatch } = this.props;
    if (item === 'buy') {
      dispatch(openDialog('buy'));
      return;
    }
    dispatch(openPurchaseDialog(item));
  };

  /**
   * Render
   * @return {Object}
   */
  render = () => {
    const { data, fateCards } = this.props;
    return (
      <FateComponent
        data={data}
        fateCards={fateCards}
        onClickBuyFateButton={this.handleClickBuyFateButton}
      />
    );
  }
}

const mapStateToProps = (state: IAppState) => {
  const { fate: { data } } = state;
  return {
    data,
    fateCards: getVisibleFateCards(state),
  };
};

export default withRouter(connect(mapStateToProps)(Fate));
